import { useProducts } from '../../../hooks/useProducts';
import { Product } from '../../../lib/store/products';
import { ALLOWED_CATEGORY_IDS } from '../../../lib/store/categoriesConfig';
import ProductCard from './ProductCard';

interface Props {
    onProductClick: (product: Product) => void;
}

export default function ProductsList({ onProductClick }: Props) {
    // Filtr kategorii jest na sztywno zadeklarowany w categoriesConfig.ts
    // i przekazywany bezpośrednio do zapytania (parametr `category`),
    // więc CoCart zwraca wyłącznie produkty z dozwolonych kategorii —
    // filtr działa przed pobraniem danych, nie ma żadnego elementu UI.
    const { data, isLoading, error } = useProducts({
        page: 1,
        per_page: 24,
        category: ALLOWED_CATEGORY_IDS,
    });

    if (error) {
        return (
            <div className="store__error">
                <p>Nie udało się załadować produktów. Spróbuj odświeżyć stronę.</p>
                <p className="store__error-detail">{String(error)}</p>
            </div>
        );
    }

    return (
        <div className="store__products-section">
            {isLoading ? (
                <div className="store__loading">
                    <div className="spinner">
                        <div className="cube1"></div>
                        <div className="cube2"></div>
                    </div>
                </div>
            ) : !data || data.data.length === 0 ? (
                <p className="store__empty">Brak produktów w sklepie.</p>
            ) : (
                <div className="store__grid">
                    {data.data.map((product: Product) => (
                        <ProductCard key={product.id} product={product} onClick={onProductClick} />
                    ))}
                </div>
            )}
        </div>
    );
}
